import { memo as Memo, useCallback, useEffect } from 'react';
import { gsap } from 'gsap';

const AppEyes = Memo(() => {
	useEffect(() => {
		window.addEventListener('mousemove', mouseMove);
		return () => {
			window.removeEventListener('mousemove', mouseMove);
		};
	}, []);

	const mouseMove = useCallback((e) => {
		const size = -5;
		const winWPart = window.innerWidth / 2;
		const winHPart = window.innerHeight / 2;
		const x = ((winWPart - e.clientX) / winWPart) * size;
		const y = ((winHPart - e.clientY) / winHPart) * size;

		gsap.killTweensOf('.AppEyes-e');
		gsap.killTweensOf('.AppEyes-m');

		gsap.to('.AppEyes-e', { duration: 0.5, x, y });
		gsap.to('.AppEyes-m', { duration: 0.5, x: x * 0.8, y: y * 0.8 });
	}, []);

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			className='ziggyEyes svg-max'
			viewBox='0 0 211.62 190.88'>
			<path d='M124.59,190.88c-.16,0-.33-.02-.5-.07l-4.75-1.41c-5.06-1.5-8.62-5.87-9.06-11.13-.4-4.77-.88-15.09-1.3-24.19-.34-7.39-.67-14.36-.87-16.61-.09-.96.62-1.81,1.59-1.9.95-.09,1.81.62,1.9,1.59.21,2.32.52,9.01.88,16.76.42,9.07.9,19.35,1.29,24.06.32,3.81,2.89,6.98,6.56,8.07l4.75,1.41c.93.27,1.46,1.25,1.18,2.18-.23.76-.92,1.25-1.68,1.25Z' />
			<path d='M76.1,190.88c-.75,0-1.45-.49-1.68-1.25-.27-.93.25-1.9,1.18-2.18l4.75-1.41c3.67-1.09,6.24-4.26,6.56-8.07.39-4.71.87-14.99,1.29-24.06.36-7.75.67-14.44.88-16.77.09-.96.94-1.67,1.9-1.58.96.09,1.67.94,1.58,1.9-.2,2.24-.53,9.22-.87,16.61-.42,9.1-.9,19.41-1.3,24.18-.44,5.26-3.99,9.63-9.05,11.13l-4.75,1.41c-.17.05-.33.07-.5.07Z' />
			<rect
				x='27.36'
				width='154.46'
				height='154.46'
			/>
			<path d='M14.46,108.18c-.9,0-1.85-.13-2.85-.4-6.15-1.7-6.81-12.88-7.38-22.75-.23-3.96-.54-9.25-1.3-10.83-.02.02-.05.04-.07.06-.74.62-1.85.52-2.46-.22-.62-.74-.52-1.85.22-2.46,1.57-1.31,2.84-1.17,3.63-.83,2.6,1.13,2.96,5.37,3.47,14.08.43,7.39,1.08,18.55,4.82,19.58,5.52,1.53,9.12-3.83,12.62-9.93.83-1.45,1.54-2.69,2.23-3.58.6-.76,1.7-.9,2.46-.3.76.6.9,1.7.3,2.46-.54.69-1.19,1.83-1.95,3.16-2.64,4.61-6.85,11.97-13.74,11.97Z' />
			<path d='M192.62,104.17c-.12,0-.24,0-.36,0-5.68-.27-10.08-3.83-13.62-6.69-1.58-1.28-3.07-2.48-4.19-2.95-.89-.37-1.32-1.39-.95-2.29.37-.89,1.4-1.32,2.29-.95,1.59.66,3.19,1.96,5.05,3.46,3.3,2.67,7.05,5.7,11.59,5.92,4.65.27,8.19-8.93,10.76-15.62,2.33-6.06,3.77-9.53,6.06-10.41.9-.34,1.92.11,2.26,1.01.34.9-.11,1.91-1.01,2.25-1.02.53-2.77,5.07-4.05,8.4-3.07,7.97-6.88,17.86-13.84,17.86Z' />
			<path
				fill='var(--color1)'
				className='AppEyes-m'
				d='M81.09,80.75v3.99h-17.61v-3.99h17.61Z'
			/>
			<g>
				<path
					fill='var(--color1)'
					className='AppEyes-e'
					d='M50.21,59.67c.67-1.3,1.58-2.3,2.73-3s2.44-1.05,3.86-1.05c1.24,0,2.33.25,3.25.75s1.67,1.13,2.24,1.89v-2.37h4.23v16.62h-4.23v-2.43c-.54.78-1.29,1.42-2.24,1.93s-2.04.76-3.29.76c-1.4,0-2.67-.36-3.83-1.08-1.15-.72-2.06-1.74-2.73-3.05-.67-1.31-1-2.81-1-4.51s.33-3.17,1-4.47ZM61.68,61.57c-.4-.73-.94-1.29-1.62-1.68-.68-.39-1.41-.58-2.19-.58s-1.5.19-2.16.57-1.2.93-1.61,1.67-.61,1.59-.61,2.59.2,1.88.61,2.62.95,1.33,1.62,1.73c.67.4,1.38.6,2.15.6s1.51-.2,2.19-.58,1.22-.95,1.62-1.68c.4-.73.6-1.61.6-2.62s-.2-1.9-.6-2.62Z'
				/>
				<path
					fill='var(--color1)'
					className='AppEyes-e'
					d='M77.69,59.67c.67-1.3,1.58-2.3,2.73-3s2.44-1.05,3.86-1.05c1.24,0,2.33.25,3.25.75s1.67,1.13,2.24,1.89v-2.37h4.23v16.62h-4.23v-2.43c-.54.78-1.29,1.42-2.24,1.93s-2.04.76-3.29.76c-1.4,0-2.67-.36-3.83-1.08-1.15-.72-2.06-1.74-2.73-3.05-.67-1.31-1-2.81-1-4.51s.33-3.17,1-4.47ZM89.16,61.57c-.4-.73-.94-1.29-1.62-1.68-.68-.39-1.41-.58-2.19-.58s-1.5.19-2.16.57-1.2.93-1.61,1.67-.61,1.59-.61,2.59.2,1.88.61,2.62.95,1.33,1.62,1.73c.67.4,1.38.6,2.15.6s1.51-.2,2.19-.58,1.22-.95,1.62-1.68c.4-.73.6-1.61.6-2.62s-.2-1.9-.6-2.62Z'
				/>
			</g>
		</svg>
	);
});

export default AppEyes;
